// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manage-cookies[data-v-5299e224]{color:#a363ff;cursor:pointer;font-size:12px}", ""]);
// Exports
module.exports = exports;
